<mwe-basic-card cardClass="ikp-basic-card-override" cardTitle="meterPoint.meterPointChangeRequest.newContractPartner" headingNodeType="h4">
  <div class="d-flex flex-column gap-3 pt-3">
    @if (changeType() === MeterPointChangeType.OCCUPIED_TO_EMPTY) {
      <ikp-new-contract-partner-empty />
    } @else {
      <ikp-contract-partner-type />
      <hr />
      <ikp-contact-information />
      <hr />
      <ikp-invoicing-information />
      <hr />
      <ikp-alternative-invoicing />
    }
  </div>
</mwe-basic-card>
